module.exports = __webpack_public_path__ + "img/title-4.5436ef19.png";